import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getRealEstatePpr } from './api';
import { EStatusNames } from './interfaces';

export const path = '/ppr/area/list/:areaId/:id/status/:status';
export const getPath = (areaId: string, id: string, status: EStatusNames) =>
  `/ppr/area/list/${areaId}/${id}/status/${status}`;

const PageTaskPprListByStatus: React.FC = (props) => {
  const { id, status } = useParams<{ id: string; status: EStatusNames }>();

  const RealEstatePpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      realEstate: () => getRealEstatePpr(id, status),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <RealEstatePpr {...props} />;
};

export default PageTaskPprListByStatus;
